module.exports = __webpack_public_path__ + "static/media/sachin.93dee25e.png";